import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

type Position = 'top' | 'center';
type Justify = 'start' | 'end' | 'center' | 'between' | 'around';

type Props = {
  name: string;
  label: string | React.ReactNode;
  position?: Position;
  justify?: Justify;
} & React.ComponentProps<'input'>;

const Positions: Record<Position, string> = {
  top: 'items-top',
  center: 'items-center',
};

const Justifications: Record<Justify, string> = {
  start: 'justify-start',
  end: 'justify-end',
  center: 'justify-center',
  between: 'justify-between',
  around: 'justify-around',
};

export const CheckBox = forwardRef<HTMLInputElement, Props>(function CheckBox(
  { name, label, position = 'top', justify = 'start', ...props },
  ref,
): React.ReactElement {
  return (
    <div className={twJoin('relative flex', Positions[position], Justifications[justify])}>
      <div className="flex h-6 items-center">
        <input
          id={name}
          name={name}
          type="checkbox"
          checked={!!props.value}
          className="size-4 rounded-none border-zinc-400 text-primary-600 focus:ring-offset-1 focus:ring-primary-600 cursor-pointer"
          {...props}
        />
      </div>

      <div className="ml-2 text-sm leading-6 font-aribau text-left flex items-center">
        <label htmlFor={name} className="font-light text-zinc-500 cursor-pointer">
          {label}
        </label>
      </div>
    </div>
  );
});
